import React from "react";

/* populate element with text */
export function SupportText() {
  return (
    <div className="px-4 py-12">
      <h2 className="text-3xl pt-8 text-slate-300 uppercase text-center">
        Support
      </h2>
      <h3 className="sm:text-5xl font-bold py-6 text-center capitalize">
        Finding the right team
      </h3>
      <p className="py-4 sm:text-3xl text-slate-300">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam
        quaerat quas expedita consequuntur tenetur dolorum dolore aliquid
        deserunt. Excepturi molestias voluptatem praesentium aut deserunt iusto
        illo neque tenetur alias voluptate.
      </p>
    </div>
  );
}
